// Salesforce global error
export const SET_GLOBAL_PLATFORM_ERROR = 'SET_GLOBAL_PLATFORM_ERROR';
export const GLOBAL_PLATFORM_ERROR_TITLE = '%1$s Error';
export const GENERIC_PLATFORM_NAME = 'Platform';
